const DESIGN_PATENT_SUFFIX = 'D';

export function getIsDesignPatent(patentType: string[]): boolean {
    return patentType.some(item => {
        return item.charAt(item.length - 1) === DESIGN_PATENT_SUFFIX;
    });
}
